export default "__VITE_ASSET__CWht7_W___"